import { create } from 'zustand';
import { skillsApi, type SkillShopEntry, type SkillType } from '@/skills/skillsApi';

interface SkillsState {
  items: SkillShopEntry[];
  loading: boolean;
  refresh: () => Promise<void>;
  countOf: (skill: SkillType) => number;
}

export const useSkillsStore = create<SkillsState>((set, get) => ({
  items: [],
  loading: false,
  refresh: async () => {
    set({ loading: true });
    try {
      const r = await skillsApi.list();
      set({ items: r.items, loading: false });
    } catch {
      set({ loading: false });
    }
  },
  countOf: (skill) => get().items.find((i) => i.skill === skill)?.owned ?? 0,
}));
